/* ---------------------------------------------------------------------------
   UF WHAT TO EXPECT — reveal animation

   Stages fade up in sequence and the connector draws between them as the
   section scrolls into view, so the timeline assembles in the order it reads.

   TWO DELIBERATE CHOICES:

   1. The hidden state is applied BY JAVASCRIPT, never in the stylesheet.
      If this file fails to load, or an observer never fires, the content is
      simply visible — copy is never hidden behind an animation that might not
      run. That is the failure mode worth designing against.

   2. Only opacity and transform are animated. Both are compositor properties,
      so nothing here triggers layout or reflow — this cannot cause the jank
      that animating height, top or width would.

   Reduced motion: the animation is not set up at all, so the section renders
   in its final state immediately.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  var REVEAL_CLASS = 'is-revealed';
  var ANIMATE_CLASS = 'uf-expect__track--animate';

  function setup(track) {
    if (track.classList.contains(ANIMATE_CLASS)) return;

    /* Adding this is what hides the stages, so it happens only once we know
       we can also reveal them. */
    track.classList.add(ANIMATE_CLASS);

    if (!('IntersectionObserver' in window)) {
      track.classList.add(REVEAL_CLASS);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(REVEAL_CLASS);
          /* Once revealed it stays revealed — replaying on every scroll past
             gets irritating fast on a page people scroll up and down. */
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(track);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice
      .call(scope.querySelectorAll('[data-uf-expect-track]'))
      .forEach(setup);
  }

  /**
   * Switching to The Lab reveals a track that was display:none until now.
   * A hidden element never intersects, so its observer never fired and its
   * stages are still sitting at opacity 0 — the pane would swap to an empty
   * section. Reveal anything that has become visible.
   */
  document.addEventListener('uf:modechange', function () {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-uf-expect-track]'))
      .forEach(function (track) {
        if (track.offsetParent === null) return;
        setup(track);
        track.classList.add(REVEAL_CLASS);
      });
  });

  function start() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Theme editor re-renders a section without a page load. */
  document.addEventListener('shopify:section:load', function (event) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    init(event.target);
  });
})();
